export default {
	name: "indexView", // 会员中心
	data() {
		return {
			navList: [],
			list: [],
			selItem: {},
			orderList: [],
			notices: [
				'1，有效期说明‌：自购买之日起生效，有效期为自然日，到期后自动失效。未使用天数不支持累计或折现。',
				'2，权限范围‌：持卡会员可免费学习平台内指定课程（部分高阶或单独付费内容除外），具体以课程页面标注为准。',
				'3，课程调整说明‌：平台可能根据运营需要调整课程内容或权限范围，调整前将通过站内信或公告通知，但不影响已生效月卡的原定权益。',
				'4，违规处理‌：若发现利用漏洞、恶意刷取权益或违反使用条款的行为，平台有权冻结账号并终止会员服务，且不退还任何费用。',
				'5，最终解释权‌：本须知未尽事宜，以平台官方说明或更新后的规则为准，最终解释权归平台所有。'
			]
		};
	},
	watch: {},
	created() {
		console.log("index created");
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		console.log("menuList", menuList);
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		await this.getUserInfo();
		await this.getVipList();
		await this.getVipOrders();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getUserInfo() {
			const infoRes = await this.$zkHttp.user$getUserInfo();
			console.log("infoRes ===> ", infoRes);
			if (infoRes) {
				this.$store.commit("auth/setLoginInfo", {
					...infoRes,
				});
			}
		},
		async getVipList() {
			const listRes = await this.$zkHttp.index$get_cards();
			console.log("listRes ===> ", listRes);
			this.list = listRes || [];
		},
		async getVipOrders() {
			const listRes = await this.$zkHttp.order$get_card_orders({
				user_id: this.$store.state.auth.user_id,
			});
			console.log("listRes ===> ", listRes);
			this.orderList = listRes || [];
		},
		showLogin() {
			if (this.$store.state.auth.token) return;
			this.$refs.headerRef.$refs.loginRef.onOpen();
		},
		onBindSuccess() {
			this.openVip(this.selItem);
		},
		async openVip(e) {
			if (!this.$store.state.auth.mobile) {
				this.selItem = {
					...e
				};
				this.$refs.tellBindRef.onOpen();
				return;
			}
			const putRes = await this.$zkHttp.order$putCardOrder({
				user_id: this.$store.state.auth.user_id,
				id: e.id
			});
			console.log("putRes ===> ", putRes);
			// id: "6"
			// out_trade_no: "617448694789242394"
			// present_id: ""
			// referred_by: 0
			// total_amount: "198.00"
			// user_id: "15"
			if (putRes && putRes.id) {
				this.getVipOrders();
				this.onPay(putRes);
			}
		},
		async onPay(e) {
			if (!e.id) return;
			this.$refs.cashierRef.onOpen("vip", e.id);
		},
	}
}